import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { SessionService } from '@edl-development/edl-common';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { EdlComment } from 'src/app/model/comment.model';
import { FileAttachment } from 'src/app/model/attachment/file-attachment.model';
import { ObservationSummaryDTO } from 'src/app/model/observation/observation-summary-dto.model';
import { FileService } from 'src/app/services/file.service';
import { CommentTags } from 'src/app/components/observation-comments/enums/comment-tags.enum';
import { CommentHelpersService } from 'src/app/components/observation-comments/services/comment-helpers/comment-helpers.service';

@Component({
    selector: 'app-file-attachment-modal',
    templateUrl: './file-attachment-modal.component.html',
    styleUrls: ['./file-attachment-modal.component.scss']
})
export class FileAttachmentModalComponent implements OnInit {
    @Input() tabIndex?: number = 1;
    @Input() observationFiles: FileAttachment[] = [];
    @Input() comment?: EdlComment;
    @Input() observationSummary?: ObservationSummaryDTO;
    @Input() attachmentLabel?:string;
    @Input() isReadOnly: boolean = false;

    get observationType() {
        return this.commentHelperService.adjustObservationType(this.observationSummary?.itemType);
    }

    form!: FormGroup;
    fileList!: FileList;
    busy:boolean = false;
    invalidFile:boolean = false;

    CommentTags = CommentTags;

    constructor(
        public activeModal: NgbActiveModal,
        private fileService:FileService,
        private formBuilder: FormBuilder,
        private sessionService: SessionService,
        private toastr: ToastrService,
        private commentHelperService: CommentHelpersService
    ) { }


    setTabIndex(num: number) {
        this.tabIndex = num;
    }

    ngOnInit(): void {
        if(!Array.isArray(this.observationFiles)) this.observationFiles = [];
        if(this.comment && Array.isArray(this.comment.attachments) ) this.observationFiles.concat(this.comment.attachments);
        this.buildForm();
    }

    close(){
        this.activeModal.close(this.observationFiles);
    }

    buildForm() {
        this.form = this.formBuilder.group({
            FileID: [null, []],
            FileName: [null, [Validators.required]],
            DisplayName: [null, []],
            FileSize: [null, []],
            FileType: [null, []],
        });
    }

    get fileNameControl() {
        return this.form.get('FileName');
    }

    isGeneralAttachment(attachment: FileAttachment){
        return attachment.commentID == "" || attachment.commentID == null;
    }

    onChange(event:any) {
        let filename = '';
        var validFExtension = ['gif','jpg','jpeg','tiff','png','doc','docx','xls','xlsx','pdf','txt','rtf','ppt','pptx','m4a','mp3','wav','aac'];
        try {
            var file = event.target.files[0];
            filename = event.target.value;
            var fileExt =  filename.substring(filename.lastIndexOf('.') + 1).toLowerCase();
            var validExtension = validFExtension.includes(fileExt);
            if(file){
                this.invalidFile = false;
                var iFileSize = file.size;
                if(iFileSize > 20971520 || !validExtension){
                    this.invalidFile = true;
                } else {

                    this.form!.get('FileName')?.setValue(filename.replace('C:\\fakepath\\', ''));
                    this.fileList = event.target.files;
                }
            }

        }
        catch(e) {

        }
    }

    submit({ value, valid }: { value: FileAttachment, valid: boolean}) {
        if (!valid) {
            this.form.markAllAsTouched();
            return;
        }

        this.busy = true;
        var cId = this.comment?.commentID?? "";
        var cLbl = this.attachmentLabel!;

        this.fileService
            .uploadFile({ fileList: this.fileList, type: this.observationType!,  typeId: this.observationSummary!.observationId, commentId: cId, commentLabel: cLbl })
            .subscribe({
                next: (resp:any)=> {
                    if(resp.status == 1){
                        this.observationFiles.push(resp.file);
                        this.toastr.success('File uploaded successfully.');
                        this.buildForm();
                    } else {
                        this.toastr.error(resp.message);
                    }
                    this.busy = false;
                },
                error: () => {
                    this.busy = false;
                }
            });
    }

    onAttachmentDeleted(attachment: FileAttachment) {
        const index = this.observationFiles.indexOf(attachment, 0);
        if (index! > -1) {
            this.observationFiles.splice(index!, 1);
        }
    }
}
